import Vue from "vue";
import Router from "vue-router";
import Login from "../views/login.vue";
import Home from "../views/home.vue";
import Practice from "../views/practice.vue";
import notDone from "../views/notDone.vue";

import Mistake from "../views/mistake.vue";
import Collection from "../views/collection.vue";
import Register from "../views/register.vue";
import Forget from "../views/forget.vue";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

let routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      auth: false,
      title: "登录",
      keepAlive: false,
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      auth: false,
      title: "首页",
      keepAlive: false,
    },
  },
  {
    path: "/practice",
    name: "practice",
    component: Practice,
    meta: {
      auth: false,
      title: "我的练习",
      keepAlive: false,
    },
  },
  {
    path: "/notDone",
    name: "notDone",
    component: notDone,
    meta: {
      auth: false,
      title: "我的练习",
      keepAlive: false,
    },
  },

  {
    path: "/mistake",
    name: "mistake",
    component: Mistake,
    meta: {
      auth: false,
      title: "我的错题",
      keepAlive: false,
    },
  },
  {
    path: "/collection",
    name: "collection",
    component: Collection,
    meta: {
      auth: false,
      title: "我的收藏",
      keepAlive: false,
    },
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      auth: false,
      title: "注册",
      keepAlive: false,
    },
  },
  {
    path: "/forget",
    name: "forget",
    component: Forget,
    meta: {
      auth: false,
      title: "忘记密码",
      keepAlive: false,
    },
  },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    routes,
  });

const myRouter = createRouter();

window.vm = myRouter;

export default myRouter;
